import React from 'react';
import { AdminRoutes } from './AdminRouter';
import { ClientRoutes } from './ClientRouter';
import { VendorRoutes } from './VendorRouter';
import { AppWrapper } from './AppWrapper';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { StandaloneLogoutRoute } from '../StandaloneLogoutRoute';
import { eAccessControlUserUrlTypes, urlAccessControlUserTypes } from '../ui-toolkit/enums/eAccessControlUserType';
import { Auth0LoginContainer } from '../pages/login/Auth0LoginContainer';
import { Auth0LoginRouterContainer } from '../pages/login/Auth0LoggedInRouterContainer';
import { Auth0ChangePasswordContainer } from '../pages/login/Auth0ChangePasswordContainer';
import { PageNotFound } from '../ui-toolkit';

export const SpaRouter = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/spa/logout" component={StandaloneLogoutRoute} />
        <Route exact path={`/spa/:userType(${urlAccessControlUserTypes})/login`} component={Auth0LoginContainer} />
        <Route exact path="/spa/logged_in" component={Auth0LoginRouterContainer} />
        <Route exact path="/spa/changedPassword" component={Auth0ChangePasswordContainer} />
        <Route path={`/spa/:userType(${urlAccessControlUserTypes})`}>
          <AppWrapper>
            <Switch>
              <Route path={`/spa/:userType(${eAccessControlUserUrlTypes.admin})`} component={AdminRoutes} />
              <Route path={`/spa/:userType(${eAccessControlUserUrlTypes.vendor})`} component={VendorRoutes} />
              <Route path={`/spa/:userType(${eAccessControlUserUrlTypes.client})`} component={ClientRoutes} />
            </Switch>
          </AppWrapper>
        </Route>
        <Route path="*" component={PageNotFound} />
      </Switch>
    </BrowserRouter>
  );
};
